<!-- 资讯详情页 -->
<template>
  <div class="detail-box safe-distance-top-header safe-distance-bottom-tool">
    <Header
      :pageTitle="detailsInfo.title ? $global.matchReg(detailsInfo.title) : ''"
      :shareInfo="shareInfo"
    />
    <Shelves v-if="isShelves" />
    <!-- 详情内容 -->
    <div v-else>
      <div class="info-box">
        <h1
          class="info-title"
          v-if="detailsInfo.title"
          v-html="detailsInfo.title"
        ></h1>
        <!-- 作者 -->
        <div v-if="detailsInfo.author" class="info-author">
          作者：{{ detailsInfo.author }}
        </div>
        <!-- 来源 -->
        <div class="info-author info-source">
          <span class="source">来源：{{ detailsInfo.source }}</span>
          <span v-if="detailsInfo.originalPublishTime">{{
            detailsInfo.originalPublishTime.slice(0, 10)
          }}</span>
        </div>
        <!-- 发布者 -->
        <div class="info-publisher-box" @click="toAllParticulars(detailsInfo)">
          <img
            class="info-publisher-img"
            :src="
              userInfo.headImg
                ? $global.imgUrl + userInfo.headImg
                : require('@/assets/img/mobile-img/default-photo.png')
            "
            alt=""
          />
          <h3 class="info-publisher-name">
            {{ userInfo.name }}
          </h3>
          <van-icon
            class="info-publisher-arrow"
            name="arrow"
            size="5px"
            color="#999999"
          />
        </div>
        <!-- 内容 -->
        <div
          v-if="detailsInfo.content"
          v-html="detailsInfo.content"
          class="info-content"
        ></div>
      </div>
      <div class="recommend-box" v-if="wenxian.length > 0">
        <div class="recommend-title">最新资讯</div>
        <ZxItem
          class="recommend-list-item"
          v-for="item in wenxian"
          :key="item.articleId"
          :title="item.title"
          :img="item.cover"
          :creatTime="item.originalPublishTime | dateFormat"
          :number="item.readPv"
          :author="item.periodical"
          @click.native="toDetail(item.articleId)"
        />
      </div>
    </div>
    <BottomTool
      :title="detailsInfo.title"
      :artSummary="detailsInfo.artSummary"
      :cover="detailsInfo.cover"
      :shareInfo="shareInfo"
    />
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import Header from "./components/detailHeader.vue";
import Shelves from "./components/shelves.vue";
import BottomTool from "./components/bottomTool.vue";
import ZxItem from "@/views/mobileView/components/listItem/zxItem.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    Header,
    Shelves,
    ZxItem,
    BottomTool,
  },
  data() {
    return {
      detailsInfo: {},
      shareInfo: {},
      wenxian: [],
      userInfo: {},
      isShelves: false,
    };
  },
  filters: {
    // 时间格式化
    dateFormat(o) {
      if (o) {
        const dt = new Date(Number(o));
        const m = (dt.getMonth() + 1 + "").padStart(2, "0");
        const d = (dt.getDate() + "").padStart(2, "0");
        return `${m}-${d}`;
      } else {
        return "";
      }
    },
  },
  mounted() {
    this.getDetail();
  },
  //方法集合
  methods: {
    // 头像名字跳学者\机构\期刊
    toAllParticulars(detailsInfo) {
      let out = this.$route.query.out;
      if (detailsInfo.userType == 0) {
        //学者跳百家
        out
          ? this.$router.push(
              `/appusesbaijia?item=0&id=${detailsInfo.createUser}&out=${out}`
            )
          : this.$router.push(
              `/appusesbaijia?item=0&id=${detailsInfo.createUser}`
            );
      } else if (detailsInfo.userType == 1) {
        //期刊跳百科
        out
          ? this.$router.push(
              `/appusesbaike?item=1&id=${detailsInfo.companyId}&out=${out}`
            )
          : this.$router.push(
              `/appusesbaike?item=1&id=${detailsInfo.companyId}`
            );
      } else if (detailsInfo.userType == 2) {
        //机构跳机构
        out
          ? this.$router.push(
              `/appusesjigou?item=2&id=${detailsInfo.companyId}&out=${out}`
            )
          : this.$router.push(
              `/appusesjigou?item=2&id=${detailsInfo.companyId}`
            );
      }
    },
    getUser(data) {
      console.log(data, "data");

      this.$apis.recomendServe
        .getAuthor({
          type: data.userType,
          userId: data.createUser,
          companyId: data.companyId ? data.companyId : "",
        })
        .then((result) => {
          this.userInfo = result.content;
        });
    },
    // 获取详情页
    async getDetail() {
      let res = await this.$apis.recomendServe.getDetails({
        articleId: this.$route.query.id,
        articleType: this.$route.query.type,
      });
      if (res.resultCode === "200") {
        this.detailsInfo = res.data.data;
        this.getUser(this.detailsInfo);
        this.getwenxian();
        // 给APP分享需要的内容
        this.shareInfo = {
          title: this.detailsInfo.title,
          artSummary: this.detailsInfo.artSummary,
          cover: this.detailsInfo.cover,
          articleId: this.$route.query.id,
          articleType: this.$route.query.type,
        };
        // 分享微信方法
        this.$global.toShare(
          this.detailsInfo.title,
          this.detailsInfo.artSummary,
          this.detailsInfo.cover
        );
      } else if (
        res.resultCode === "10401002" ||
        res.resultCode === "10401001"
      ) {
        this.isShelves = true;
      }
    },
    // 获取相似文献
    async getwenxian() {
      const { data } = await this.$apis.recomendServe.getwenxian({
        companyId: this.detailsInfo.companyId,
        pageNo: 1,
        pageSize: 5,
        // title: "专著",
      });
      this.wenxian.push(...data.list);
    },
    // 跳转到详情
    toDetail(id) {
      let out = this.$route.query.out;
      out
        ? this.$router.push(`/msgDetails?id=${id}&type=5&out=${out}`)
        : this.$router.push(`/msgDetails?id=${id}&type=5`);
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep iframe {
  max-width: 100% !important;
  max-height: 200px !important;
}
::v-deep img {
  max-width: 100% !important;
}
.detail-box {
  padding-top: 56px;
  padding-bottom: 61px;
  background: #f5f5f5;
  min-height: 100vh;
  .info-box {
    margin: 0 auto;
    padding: 12px;
    width: 351px;
    background: #ffffff;
    border-radius: 8px;
    .info-title {
      margin-bottom: 20px;
      font-size: 17px;
      color: #333333;
      line-height: 24px;
      overflow: hidden;
    }
    .info-author {
      margin-top: 10px;
      font-size: 13px;
      color: #999999;
      line-height: 19px;
    }
    .info-source {
      display: flex;
      justify-content: space-between;
      .source {
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .info-publisher-box {
      position: relative;
      display: flex;
      align-items: center;
      margin: 22px auto;
      padding: 6px 12px;
      width: 327px;
      background: #f5f5f5;
      border-radius: 6px;
      .info-publisher-img {
        margin-right: 12px;
        width: 40px;
        height: 40px;
        border-radius: 50%;
      }
      .info-publisher-name {
        font-size: 14px;
        color: #333333;
        line-height: 20px;
      }
      .info-publisher-arrow {
        position: absolute;
        right: 13px;
        top: 20px;
      }
    }

    .info-content {
      margin-top: 16px;
      font-size: 18px;
      line-height: 2;
      font-weight: 500;
      color: #303030;
      overflow: hidden;
      &::v-deep img,
      &::v-deep video {
        max-width: 100% !important;
      }
      &::v-deep span {
        white-space: normal !important;
      }
    }
  }
  .recommend-box {
    margin: 12px auto 0;
    padding: 12px;
    width: 351px;
    background: #ffffff;
    border-radius: 8px;
    .recommend-title {
      font-size: 17px;
      font-weight: 700;
      color: #333333;
      line-height: 24px;
    }
    .recommend-list-item {
      border-bottom: 1px solid #eee;
      &:last-child {
        border-bottom: none;
      }
    }
  }
}
</style>
